import { motion } from 'framer-motion';
import GlassCard from '../ui/GlassCard';

export default function Features() {
    const features = [
        {
            title: "AI Analysis",
            description: "Get instant feedback on your answers, clarity, and confidence levels.",
            icon: "ri-brain-line",
            color: "text-purple-400"
        },
        {
            title: "Video Recording",
            description: "Record your practice sessions to review your body language and eye contact.",
            icon: "ri-video-chat-line",
            color: "text-blue-400"
        },
        {
            title: "Real-time Feedback",
            description: "Receive live coaching tips while you speak to adjust on the fly.",
            icon: "ri-feedback-line",
            color: "text-green-400"
        },
        {
            title: "Industry Specific",
            description: "Practice questions tailored to Software Engineering, PM, Design, and more.",
            icon: "ri-briefcase-line",
            color: "text-orange-400"
        },
        {
            title: "Speech Analytics",
            description: "Track your filler words, pacing, and tone variations over time.",
            icon: "ri-bar-chart-groupped-line",
            color: "text-pink-400"
        },
        {
            title: "Progress Tracking",
            description: "Visualize your improvement with detailed reports and score history.",
            icon: "ri-line-chart-line",
            color: "text-cyan-400"
        }
    ];

    return (
        <section id="features" className="py-32 relative">
            <div className="max-w-7xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-20"
                >
                    <h2 className="text-4xl md:text-5xl font-bold mb-6">
                        Everything you need to <br />
                        <span className="text-gradient">Ace the Interview</span>
                    </h2>
                    <p className="text-zinc-400 max-w-2xl mx-auto text-lg">
                        Our comprehensive platform provides all the tools and insights you need to excel in any interview situation.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {features.map((feature, index) => (
                        <GlassCard key={index} delay={index * 0.1}>
                            <div className={`w-12 h-12 rounded-xl bg-white/[0.05] flex items-center justify-center mb-6 ${feature.color}`}>
                                <i className={`${feature.icon} text-2xl`}></i>
                            </div>
                            <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
                            <p className="text-zinc-400 leading-relaxed">
                                {feature.description}
                            </p>
                        </GlassCard>
                    ))}
                </div>
            </div>
        </section>
    );
}
